import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getCopPageData = async () => {
  const data = await fetchData(ENDPOINTS.GET.COP_PAGE, {
    method: METHODS.GET,
  });
  return data;
};
